import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.object.values";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from 'prop-types';
import React from 'react';
import Helmet from 'react-helmet';
import classNames from 'classnames';
import { FormattedDate, FormattedMessage } from 'react-intl';
import { addDays } from 'date-fns';
import { shiftDateObjectByTimezone } from 'tz-offsets';
import { localDate, parseIso8601Date } from 'helpers/time';
import VenueDeriver from 'derivers/Venue';
import SchedulesDeriver from 'derivers/Schedules';
import { ga } from 'helpers/multitrack';
import { isEmpty } from 'helpers/verify';
import getScheduleAction from 'helpers/getScheduleAction';
import trackDwell from 'decorators/TrackDwell/TrackDwell';
import { DateBar } from './DateBar';
import { ScheduleRow } from './ScheduleRow';
import { NextCycleMessage, NoSchedulesTodayMessage, NoSchedulesSelectedDateMessage, NoSchedulesOfClassTodayMessage, SchedulesLoadingMessage, SchedulesErrorMessage } from './Messages';
var COLLAPSED_SIZE = 6;
var MAX_UPCOMING_SIZE = 12;
export var ScheduleUnwrapped =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ScheduleUnwrapped, _React$Component);

  function ScheduleUnwrapped(props) {
    var _this;

    _classCallCheck(this, ScheduleUnwrapped);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ScheduleUnwrapped).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "formatDate", function (scheduleDate) {
      var tomorrowDateInTimezone = addDays(_this.todayDateInTimezone, 1);
      var scheduleDateObject = parseIso8601Date(scheduleDate);
      var formattedMonthDay = React.createElement(FormattedDate, {
        id: "schedule.date.month.day",
        value: scheduleDateObject,
        month: "long",
        day: "numeric"
      });

      if (scheduleDate === localDate(_this.todayDateInTimezone)) {
        return React.createElement(FormattedMessage, {
          id: "schedule.today",
          defaultMessage: "Today, {date}",
          values: {
            date: formattedMonthDay
          }
        });
      } else if (scheduleDate === localDate(tomorrowDateInTimezone)) {
        return React.createElement(FormattedMessage, {
          id: "schedule.tomorrow",
          defaultMessage: "Tomorrow, {date}",
          values: {
            date: formattedMonthDay
          }
        });
      }

      return React.createElement(FormattedDate, {
        id: "schedule.date",
        value: scheduleDateObject,
        month: "long",
        day: "numeric",
        weekday: "long"
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleRetryLoad", function () {
      var _this$props = _this.props,
          selectedDateInVenueTimezone = _this$props.selectedDateInVenueTimezone,
          onRequestScheduleForDate = _this$props.onRequestScheduleForDate;
      onRequestScheduleForDate(selectedDateInVenueTimezone);
    });

    _defineProperty(_assertThisInitialized(_this), "generateVisibleSchedule", function () {
      var _reduce;

      var _this$props2 = _this.props,
          expanded = _this$props2.expanded,
          multiDay = _this$props2.multiDay,
          selectedDateInVenueTimezone = _this$props2.selectedDateInVenueTimezone,
          timezone = _this$props2.timezone;
      var schedule = _this.props.schedule || [];
      return (expanded ? schedule : schedule.slice(0, COLLAPSED_SIZE)).reduce(function (memo, klass) {
        var classDate = new Date(klass.starttime * 1e3);
        var classDateInTimezone = shiftDateObjectByTimezone(classDate, timezone);
        var formattedClassDate = localDate(classDateInTimezone);

        if (formattedClassDate !== selectedDateInVenueTimezone) {
          if (!multiDay) {
            // Ignore schedules from dates other than the selected one if multiDay isn't enabled.
            return memo;
          }

          if (memo[selectedDateInVenueTimezone].length > COLLAPSED_SIZE) {
            // We don't add future classes if we have enough classes on the selected day.
            return memo;
          }

          if (memo.totalClasses >= MAX_UPCOMING_SIZE) {
            // We don't add more future classes if we have hit the limit for number of upcoming classes to display.
            return memo;
          }
        }

        memo.totalClasses += 1;
        memo[formattedClassDate] = memo[formattedClassDate] || [];
        memo[formattedClassDate].push(klass);
        return memo;
      }, (_reduce = {}, _defineProperty(_reduce, selectedDateInVenueTimezone, []), _defineProperty(_reduce, "totalClasses", 0), _reduce));
    });

    var _timezone = _this.props.timezone;
    _this.todayDateInTimezone = shiftDateObjectByTimezone(new Date(), _timezone);
    return _this;
  }

  _createClass(ScheduleUnwrapped, [{
    key: "onDwell",
    value: function onDwell() {
      ga('Venue Details', 'View Module', 'schedule', 0, {
        nonInteraction: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          classId = _this$props3.classId,
          expanded = _this$props3.expanded,
          extraClass = _this$props3.extraClass,
          hideCtas = _this$props3.hideCtas,
          hideDateHeader = _this$props3.hideDateHeader,
          includeJsonMetadata = _this$props3.includeJsonMetadata,
          isViewingNextCycle = _this$props3.isViewingNextCycle,
          loading = _this$props3.loading,
          memberStatus = _this$props3.memberStatus,
          multiDay = _this$props3.multiDay,
          nameOfClass = _this$props3.nameOfClass,
          noLink = _this$props3.noLink,
          numberOfDaysToShow = _this$props3.numberOfDaysToShow,
          onRequestScheduleForDate = _this$props3.onRequestScheduleForDate,
          onToggleExpand = _this$props3.onToggleExpand,
          ratingsByClass = _this$props3.ratingsByClass,
          schedule = _this$props3.schedule,
          selectedDateInVenueTimezone = _this$props3.selectedDateInVenueTimezone,
          timezone = _this$props3.timezone,
          venueUrl = _this$props3.venueUrl,
          didError = _this$props3.didError;

      var _this$generateVisible = this.generateVisibleSchedule(),
          totalClasses = _this$generateVisible.totalClasses,
          visibleSchedule = _objectWithoutProperties(_this$generateVisible, ["totalClasses"]);

      var selectedDateHasClasses = !isEmpty(visibleSchedule[selectedDateInVenueTimezone]);
      var scheduleDates = Object.keys(visibleSchedule);
      var content;

      if (loading) {
        content = React.createElement(SchedulesLoadingMessage, null);
      } else if (didError) {
        content = React.createElement(SchedulesErrorMessage, {
          onClick: this.handleRetryLoad
        });
      } else if (totalClasses > 0) {
        var _ref;

        var expandCollapseEnabled = schedule.length > COLLAPSED_SIZE;
        content = React.createElement("div", null, includeJsonMetadata && !isEmpty(scheduleDates) && React.createElement(Helmet, null, React.createElement("script", {
          type: "application/ld+json"
        }, JSON.stringify((_ref = []).concat.apply(_ref, _toConsumableArray(Object.values(visibleSchedule))).map(function (sch) {
          return {
            '@context': 'http://schema.org',
            '@type': 'Event',
            name: sch.class.name,
            startDate: new Date(sch.starttime * 1e3).toISOString(),
            endDate: new Date(sch.endtime * 1e3).toISOString(),
            url: "https://classpass.com/classes/".concat(sch.venue.alias, "/").concat(sch.class.alias, "/").concat(sch.id),
            location: {
              '@type': 'Place',
              name: "".concat(sch.venue.name),
              address: "".concat(VenueDeriver.address(sch.venue))
            }
          };
        })))), isViewingNextCycle && React.createElement(NextCycleMessage, null), scheduleDates.map(function (date) {
          return React.createElement("div", {
            key: date,
            className: "schedule__row-wrapper"
          }, multiDay && (date === selectedDateInVenueTimezone && !selectedDateHasClasses && React.createElement(NoSchedulesSelectedDateMessage, {
            date: _this2.formatDate(date)
          }) || React.createElement("div", {
            className: "schedule__row-header"
          }, _this2.formatDate(date))), visibleSchedule[date].map(function (sch) {
            return React.createElement(ScheduleRow, _extends({}, SchedulesDeriver.availabilityData(sch), {
              activities: sch.class.activities,
              availabilityLabel: sch.availability && sch.availability.label,
              callToAction: sch && getScheduleAction(memberStatus, sch),
              className: sch.class.name,
              creditPrice: sch.availability && sch.availability.credits,
              endTime: sch.endtime,
              hideCta: hideCtas,
              itemUrl: noLink ? null : "/classes/".concat(sch.venue.alias, "/").concat(sch.class.alias, "/").concat(sch.id),
              key: "schedule_".concat(sch.id),
              rating: ratingsByClass && ratingsByClass[sch.class.alias],
              schedule: sch,
              startTime: sch.starttime,
              teacherName: sch.teacher.name,
              timezone: timezone
            }));
          }));
        }), onToggleExpand && expandCollapseEnabled && React.createElement("div", {
          className: "schedule__row schedule__row--fullwidth schedule__row__more",
          onClick: function onClick() {
            ga('Venue Details', 'See Full Schedule Click');
            onToggleExpand();
          }
        }, React.createElement("a", null, expanded ? React.createElement(FormattedMessage, {
          id: "schedule.collapse",
          defaultMessage: "Show less"
        }) : React.createElement(FormattedMessage, {
          id: "schedule.expand",
          defaultMessage: "Show more"
        }))));
      } else {
        content = classId ? React.createElement(NoSchedulesOfClassTodayMessage, {
          nameOfClass: nameOfClass,
          venueUrl: venueUrl
        }) : React.createElement(NoSchedulesTodayMessage, null);
      }

      var date = selectedDateInVenueTimezone ? parseIso8601Date(selectedDateInVenueTimezone) : shiftDateObjectByTimezone(new Date(), timezone);
      return React.createElement("div", {
        className: classNames('schedule', extraClass)
      }, !hideDateHeader && React.createElement("div", {
        className: "schedule__date"
      }, React.createElement(FormattedDate, {
        value: date,
        weekday: "long",
        month: "long",
        day: "numeric"
      })), React.createElement(DateBar, {
        extraClass: !multiDay || !selectedDateHasClasses ? '' : 'schedule__datebar--no-border-bottom',
        numberOfDaysToShow: numberOfDaysToShow || 14,
        selectedDateInVenueTimezone: date,
        onDateClick: function onDateClick(forDate) {
          ga('Venue Details', 'Change Schedule Click');
          onRequestScheduleForDate(forDate);
        },
        timezone: timezone
      }), React.createElement("div", {
        className: "schedule__rows"
      }, content));
    }
  }]);

  return ScheduleUnwrapped;
}(React.Component);
ScheduleUnwrapped.propTypes = {
  classId: PropTypes.number,
  expanded: PropTypes.bool,
  extraClass: PropTypes.string,
  hideCtas: PropTypes.bool,
  hideDateHeader: PropTypes.bool,
  includeJsonMetadata: PropTypes.bool,
  isViewingNextCycle: PropTypes.bool,
  loading: PropTypes.bool,
  didError: PropTypes.bool,
  memberStatus: PropTypes.string,
  multiDay: PropTypes.bool,
  nameOfClass: PropTypes.string,
  noLink: PropTypes.bool,
  numberOfDaysToShow: PropTypes.number,
  onRequestScheduleForDate: PropTypes.func,
  onToggleExpand: PropTypes.func,
  ratingsByClass: PropTypes.object,
  schedule: PropTypes.array,
  selectedDateInVenueTimezone: PropTypes.string,
  timezone: PropTypes.string.isRequired,
  userPermissions: PropTypes.object,
  venueUrl: PropTypes.string
};
export var Schedule = trackDwell(ScheduleUnwrapped);